import React from 'react';

import ScreenLoaderAnimation from './ScreenLoaderAnimation';

function ScreenLoader() {
  return (
    <div className="w-full h-full bg-white bg-opacity-100 absolute inset-0 pointer-events-none">
      <div className="flex justify-center items-center h-full bg-opacity-50">
        <ScreenLoaderAnimation />
      </div>
    </div>
  );
}

ScreenLoader.defaultProps = {};

ScreenLoader.propTypes = {};

export default ScreenLoader;
